import { Badge, type BadgeTone } from "@/components/ui/badge"
import type { TicketPriority } from "@/types/ticket"

const PRIORITY_TONE: Record<TicketPriority, BadgeTone> = {
  urgent: "error",
  high:   "warning",
  normal: "neutral",
  low:    "neutral",
}

const PRIORITY_LABEL: Record<TicketPriority, string> = {
  urgent: "Urgent",
  high:   "High",
  normal: "Normal",
  low:    "Low",
}

type Props = { priority: TicketPriority }

export function TicketPriorityBadge({ priority }: Props) {
  return <Badge tone={PRIORITY_TONE[priority]}>{PRIORITY_LABEL[priority]}</Badge>
}
